<div
  class="modal-container"
  [class.full-screen]="fullScreen"
  [class.fill-viewport-height]="fillViewportHeight"
>
  <header class="modal-header">
    <div>
      <h4>{{ title }}</h4>
      <small class="text-secondary">{{ subtitle }}</small>
    </div>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      data-testid="generic-modal-close-x"
      (click)="closeModal()"
    ></button>
  </header>

  <main class="modal-content">
    <ng-content select="[body]"></ng-content>
  </main>

  @if (showFooter) {
  <footer class="modal-footer">
    <ng-content select="[footer]"></ng-content>
  </footer>
  }
</div>